import request from '@/utils/request'

// 查询店铺类型列表
export function queryShopType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.queryShopType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增店铺类型
export function saveShopType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.saveShopType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改店铺类型
export function updateShopType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.updateShopType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除店铺类型
export function deleteShopType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopType.deleteShopType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}